import { render, staticRenderFns } from "./GastosTab.vue?vue&type=template&id=98557608&scoped=true"
import script from "./GastosTab.vue?vue&type=script&lang=js"
export * from "./GastosTab.vue?vue&type=script&lang=js"
import style0 from "./GastosTab.vue?vue&type=style&index=0&id=98557608&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98557608",
  null
  
)

export default component.exports